import type { GranularityType, ValueType } from "./types";

export const VALUE_TYPE_OPTIONS = [{ label: "#" }, { label: "%" }];

export const GRANULARITY_OPTIONS = [{ label: "D" }, { label: "W" }, { label: "M", disabled: true }];

export const GRANULARITY_MAP: GranularityType[] = ["Day", "Week"];

export const getValueTypeIndex = (valueType: ValueType): number => (valueType === "absolute" ? 0 : 1);

export const getGranularityIndex = (granularity: GranularityType): number => GRANULARITY_MAP.indexOf(granularity);
